import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { TextField, Select, Checkbox } from "redux-form-material-ui";
import { FormControlLabel } from "material-ui";
import { MenuItem } from "material-ui/Menu";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";
import { InputLabel } from "material-ui/Input";

import { validEmail } from "../utils/validators";
import CenteredForm from "../utils/form/CenteredForm";
import {
  required,
  email,
  companynumber,
  date,
  subdomain,
} from "../utils/form/formValidation";
import UserNotAuthenticated from "../utils/auth/UserNotAuthenticated";
import { signupRequest, specilityRequest } from "./actions";
import styles from "./Signup.scss";
import Modal from "../utils/modal/modal";
import CheckboxWithLabelAndError from "../utils/checkbox/checkBoxValidation";
import FontAwesome from "react-fontawesome";
import { Env } from "../../env";
const normalizeLower = (value) => value && value.toLowerCase();

class Signup extends React.Component {
  static propTypes = {
    initialize: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    signupRequest: PropTypes.func.isRequired,
    specilityRequest: PropTypes.func.isRequired,
    signup: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
      specilitys: PropTypes.arrayOf(PropTypes.any),
    }).isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  constructor() {
    super();
    this.state = {
      agreeToTerms: false,
      date: "",
      isModalOpen: false,
      domainAlreadyUsed: false,
      autoFocusSubdomainCalled: false,
      multiDoctor: false,
      plans: [
        { name: "basic", fullName: "Basic" },
        { name: "premium", fullName: "Premium" },
        { name: "tv", fullName: "TV fournie" },
      ],
      autoSelectedPlan: null,
      emailCustomer: "Votre adresse email",
      showMdp: false,
    };
  }

  gotUserEmail() {
    var email = this.refs.email.value;
    if (email && email.length && validEmail(email)) {
      var xhr = new XMLHttpRequest();
      xhr.open("POST", `${Env.BASE_API_URL}/SignupInfos`);
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
      xhr.send("email=" + encodeURIComponent(email));
    }
  }

  handleBlur = () => {
    this.gotUserEmail();
  };

  componentWillMount() {
    this.props.specilityRequest();
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.plan
    ) {
      localStorage.setItem("autoSelectedPlan", this.props.match.params.plan);
      this.setState({
        autoSelectedPlan: this.props.match.params.plan,
      });
    } else if (localStorage.getItem("autoSelectedPlan")) {
      this.setState({
        autoSelectedPlan: localStorage.getItem("autoSelectedPlan"),
      });
    } else {
      console.log("def plan selcted");
      /*this.props.initialize({
            plan: "basic"
         })*/
    }
    // Active event fb
    switch (localStorage.getItem("autoSelectedPlan")) {
      case "basic":
        fbq("track", "AddToCart", {
          content_name: "Plan basic",
          value: 39,
          currency: "EUR",
        });
        console.log("EVENT BASIC");
        break;
      case "premium":
        fbq("track", "AddToCart", {
          content_name: "Plan premium",
          value: 69,
          currency: "EUR",
        });
        console.log("EVENT PREMIUM");
        break;
      case "tv":
        fbq("track", "AddToCart", {
          content_name: "Plan tv",
          value: 89,
          currency: "EUR",
        });
        console.log("EVENT TV");
        break;
      default:
        fbq("track", "AddToCart", {
          content_name: "basic",
          value: 39,
          currency: "EUR",
        });
        console.log("EVENT TV");
        console.log(
          "Sorry, we are out of " + localStorage.getItem("autoSelectedPlan")
        );
    }
    if (
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.email
    ) {
      console.log("LA " + this.props.match.params.email);
      this.setState({
        emailCustomer: this.props.match.params.email,
      });
      console.log("LA " + this.props.match.params.email);
    }
    this.props.initialize({
      specialityId: "5cb842568e50be6a39b56f97",
    });
  }
  submit = (values) => {
    console.log("values AVANT L'EMAIL", values);
    if (this.state.autoSelectedPlan) {
      //inject plan type received in url params
      values.plan = this.state.autoSelectedPlan;
    }
    console.log("plan is", values.plan);
    this.setState({ isModalOpen: false });
    this.props.signupRequest(values);
  };

  handleMultiDoctorCheckbox = (a) => {
    this.setState({
      multiDoctor: !this.refs.multiDoctor.value,
    });
  };

  componentWillUpdate = () => {
    if (this.state.multiDoctor) {
    }
  };

  getTranslatedError(error) {
    if (error == "Email already exists")
      return "Cette adresse email est déjà utilisée";
    return error;
  }

  toggleShowMdp = () => {
    if (this.state.showMdp) {
      document.getElementById("Password").setAttribute("type", "password");
      document.getElementById("Eye").style.color = "#7a797e";
      this.setState({
        showMdp: false,
      });
    } else {
      document.getElementById("Password").setAttribute("type", "text");
      document.getElementById("Eye").style.color = "#5887ef";
      this.setState({
        showMdp: true,
      });
    }
  };
  render() {
    const {
      handleSubmit,
      signup: { error, requesting, specilitys },
      snackbarMessage,
    } = this.props;
    let plans = this.state.plans;
    let forcePlanChange = false;

    // Multidoctor can't be picked in basic plan, so disable basic plan if multidoctor is checked
    if (this.state.multiDoctor) {
      plans = plans.filter((plan) => {
        return plan.name !== "basic";
      });
      if (this.refs.plan && this.refs.plan.value == "basic")
        forcePlanChange = true;
    }

    let autoSelectedPlan = this.state.autoSelectedPlan;
    if (autoSelectedPlan == "basic" && this.state.multiDoctor) {
      forcePlanChange = true;
      autoSelectedPlan = false;
    }

    return (
      <div>
        <CenteredForm
          title=""
          handleOnSubmit={handleSubmit(this.submit)}
          snackbarMessage={snackbarMessage}
          style={{
            position: "inherit",
            top: "0",
            left: "0",
            transform: "inherit",
            margin: "auto",
            minWidth: "234px",
          }}
        >
          <h1 className={styles.title_signup}>
            Le futur de l'information médicale.
          </h1>
          <h3 className={styles.titleUnderSignup}>
            Les cabinets médicaux les plus innovants sont sur Digidocteur.
            Rejoignez-nous en deux minutes !
          </h3>
          <div className={styles.signupBox}>
            <div className="mb2">
              <Field
                name="email"
                placeholder={this.state.emailCustomer}
                label={this.state.emailCustomer}
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                validate={[required, email]}
                fullWidth
                normalize={normalizeLower}
                withRef
                ref="email"
                onBlur={this.handleBlur}
              />
              <p className="custom-error-message">
                {!!error ? this.getTranslatedError(error.email) : ""}
              </p>
            </div>
            <div className="mb2" id={styles.PasswordField}>
              <Field
                name="password"
                id="Password"
                type="password"
                placeholder="Votre mot de passe"
                label="Votre mot de passe"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                  autoComplete: "new-password",
                }}
                component={TextField}
                validate={required}
                fullWidth
                withRef
                ref="password"
              />
              <div id="SpanIcon" className={styles.spanIcon}>
                <FontAwesome
                  id="Eye"
                  style={{ color: "#7a797e" }}
                  className="fas fa-eye"
                  name="eye"
                  onClick={() => this.toggleShowMdp()}
                />
              </div>
              <p className="custom-error-message">
                {!!error ? error.password : ""}
              </p>
            </div>
            <div className="mb2">
              <InputLabel htmlFor="model">Votre spécialité Médicale</InputLabel>
              <Field
                name="specialityId"
                component={Select}
                placeholder="Ophtalmologie, Dentaire..."
                fullWidth
                validate={required}
                withRef
                ref="specialityId"
              >
                {specilitys &&
                  specilitys.map((specility) => (
                    <MenuItem key={specility.id} value={specility.id}>
                      {specility.name}
                    </MenuItem>
                  ))}
              </Field>
            </div>
            {!this.state.multiDoctor && (
              <div
                style={{ display: this.state.multiDoctor ? "none" : "block" }}
              >
                <div className="mb2">
                  <Field
                    name="firstName"
                    placeholder="Votre prénom"
                    label="Votre prénom"
                    inputProps={{
                      autoCorrect: "off",
                      autoCapitalize: "none",
                    }}
                    component={TextField}
                    validate={[required]}
                    fullWidth
                    withRef
                    ref="firstName"
                  />
                  <p className="custom-error-message">
                    {!!error ? error.firstName : ""}
                  </p>
                </div>
                <div className="mb2">
                  <Field
                    name="lastName"
                    placeholder="Votre nom"
                    label="Votre nom"
                    inputProps={{
                      autoCorrect: "off",
                      autoCapitalize: "none",
                    }}
                    component={TextField}
                    validate={[required]}
                    fullWidth
                    withRef
                    ref="lastName"
                  />
                  <p className="custom-error-message">
                    {!!error ? error.lastName : ""}
                  </p>
                </div>
              </div>
            )}
            <div className="mb2">
              <FormControlLabel
                control={
                  <Field
                    name="multiDoctor"
                    component={Checkbox}
                    withRef
                    ref="multiDoctor"
                    checked={this.state.multiDoctor}
                    onChange={this.handleMultiDoctorCheckbox}
                  />
                }
                label={<span>Cochez si vous avez un cabinet de groupe</span>}
              />
              <p className="custom-error-message">
                {!!error ? error.multiDoctor : ""}
              </p>
            </div>
            {this.state.multiDoctor && (
              <div className="mb2">
                <Field
                  name="multiDoctorNames"
                  placeholder="Ex: 'Vincent Paoli et Pascal Giammattei'"
                  label="Noms des médecins"
                  inputProps={{
                    autoCorrect: "off",
                    autoCapitalize: "none",
                  }}
                  component={TextField}
                  validate={[required]}
                  fullWidth
                  withRef
                  ref="multiDoctorNames"
                />
                <p className="custom-error-message">
                  {!!error ? error.lastName : ""}
                </p>
              </div>
            )}
            <div className="mb2" style={{ display: "none" }}>
              <Field
                name="birthdate"
                placeholder="JJ/MM/AAAA"
                label="Date de naissance"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                validate={[date]}
                component={TextField}
                normalize={(value) => {
                  if (
                    /(^\d{0,2}$)|(^\d{2}\/$)|(^\d{2}\/\d{0,2}$)|(^\d{2}\/\d{2}\/\d{0,4}$)/.test(
                      value
                    )
                  ) {
                    return value;
                  } else {
                    return value.slice(0, value.length - 1);
                  }
                }}
                fullWidth
                withRef
                ref="birthdate"
              />
              <p className="custom-error-message">
                {!!error ? error.birthdate : ""}
              </p>
            </div>
            {!autoSelectedPlan && (
              <div className="mb2">
                <InputLabel htmlFor="model">Forfait choisi</InputLabel>
                <Field
                  name="plan"
                  component={Select}
                  placeholder="Basique, premium ou avec TV fournie"
                  fullWidth
                  validate={required}
                  withRef
                  onChange={(e) => {
                    this.setState({ autoSelectedPlan: null });
                  }}
                  ref="plan"
                >
                  {plans.map((plan) => (
                    <MenuItem key={plan.name} value={plan.name}>
                      {plan.fullName}
                    </MenuItem>
                  ))}
                </Field>
              </div>
            )}
          </div>
          <label className="mb6" style={{ display: "none" }}>
            <h3>Informations sur votre société</h3>
          </label>
          <div className={styles.signupBox} style={{ display: "none" }}>
            <div className="mb2">
              <Field
                name="companynumber"
                placeholder="SIRET"
                label="SIRET"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                validate={[companynumber]}
                normalize={(value) => {
                  if (/([\d]$)/.test(value)) {
                    return value;
                  } else {
                    return value.slice(0, value.length - 1);
                  }
                }}
                fullWidth
                withRef
                ref="companynumber"
              />
              <p className="custom-error-message">
                {!!error ? error.companynumber : ""}
              </p>
            </div>
            <div className="mb2">
              <Field
                name="companyname"
                placeholder="Raison sociale"
                label="Raison sociale"
                inputProps={{
                  autoCorrect: "off",
                  autoCapitalize: "none",
                }}
                component={TextField}
                fullWidth
                withRef
                ref="companyname"
              />
              <p className="custom-error-message">
                {!!error ? error.companyname : ""}
              </p>
            </div>
          </div>
          {forcePlanChange && (
            <p style={{ textAlign: "center", color: "#f44336" }}>
              Le plan "Basic" n'est pas disponible pour les cabinets de groupe.
              Choisissez le forfait Premium ou TV Fournie selon vos besoins.
            </p>
          )}
          <div className="mb2">
            <Field
              color="primary"
              name="agreeToTerms"
              className={styles.checkbox}
              classes={{
                checked: styles.checked,
                checkboxError: styles.checkboxAgreeError,
              }}
              label={
                <div>
                  J'accepte les&nbsp;
                  <Link
                    style={{ textDecoration: "underline" }}
                    to={
                      "https://digidocteur.s3.eu-central-1.amazonaws.com/legal/conditions_generales_d_utilisation_digidocteur.pdf"
                    }
                    target="_blank"
                  >
                    CGU
                  </Link>
                  &nbsp;et la&nbsp;
                  <Link
                    style={{ textDecoration: "underline" }}
                    to={
                      "https://digidocteur.s3.eu-central-1.amazonaws.com/legal/politique_de_confidentialite_digidocteur.pdf"
                    }
                    target="_blank"
                  >
                    Politique de confidentialité
                  </Link>
                </div>
              }
              component={CheckboxWithLabelAndError}
              validate={[required]}
            />
          </div>
          {!forcePlanChange && (
            <Button
              onClick={handleSubmit((values) => {
                console.log(values);
                fbq("track", "CompleteRegistration");
                console.log("EVENT COMPLETE REGISTRATION");
                this.openModal();
              })}
              className="mb6"
              variant="raised"
              color="primary"
              fullWidth
            >
              {!requesting && "S'inscrire"}
              {requesting && <CircularProgress className={styles.requesting} />}
            </Button>
          )}
          <div>
            <Button color="primary" href="/login" className={styles.linkSignIn}>
              Vous avez déjà un compte ? Cliquez ici pour vous connecter
            </Button>
            <br />
            <p
              style={{
                fontSize: "12px",
                textAlign: "center",
                color: "#2196F3",
              }}
            >
              <a
                style={{ color: "#2196F3" }}
                target="_blank"
                href="https://digidocteur.s3.eu-central-1.amazonaws.com/legal/politique_de_confidentialite_digidocteur.pdf"
              >
                Voir la politique de confidentialité
              </a>
            </p>
          </div>
          <Modal
            isOpen={this.state.isModalOpen || this.isDomainAlreadyUsed(error)}
            onClose={() => this.closeModal(error)}
          >
            <div style={{ padding: "25px" }}>
              <h1 className="mb3">Choisir un nom de domaine</h1>
              <div className="mb6">
                <Field
                  name="subdomainText"
                  placeholder="nom-du-médecin"
                  label="Sous-domaine"
                  inputProps={{
                    autoCorrect: "off",
                    autoCapitalize: "none",
                    className: "text-align-right " + styles.subdomainText,
                  }}
                  onFocus={(e) => this.subDomainFocus()}
                  component={TextField}
                  validate={[required, subdomain]}
                  // normalize={(value) => {
                  //  if (/([\d]$)/.test(value)) {
                  //      return value;
                  //  } else {
                  //      return value.slice(0, value.length - 1);
                  //  }
                  // return this.modifiySubdomain(value);
                  // }}
                  style={{ width: "60%", textTransform: "lowercase" }}
                  autoFocus
                />
                <label style={{ width: "40%" }}>.digidocteur.com</label>
                <p className="custom-error-message">
                  {!!error ? error.subdomain : ""}
                </p>
                <h3>Qu'est-ce que c'est ?</h3>
                <p style={{ fontSize: "14px" }}>
                  Nous allons créer un site web pour votre cabinet !<br />
                  Vos patients pourront trouver votre cabinet en adresse en
                  ligne, et consulter les vidéos médicales que nous allons créer
                  pour vous.
                  <br />
                  C'est un excellent moyen d'informer vos patients.
                </p>
                <h3>Comment choisir un nom de domaine ?</h3>
                <p style={{ fontSize: "14px" }}>
                  Vous pouvez utiliser votre nom de cabinet ou de famille par
                  exemple. Les espaces et les accents ne sont pas acceptés.
                </p>
              </div>
              {/* 
                     <div className="row pull-right"> */}
              <Button
                className="mr1 mb1 pull-right"
                variant="raised"
                color="secondary"
                type={requesting ? "" : "submit"}
              >
                {" "}
                {!requesting && "S'inscrire"}
              </Button>
              {/* <Button className="mb1 mr1"
                     variant="raised"
                     color="primary" onClick={() => this.closeModal()}>Close</Button> */}
              {/* 
                     </div>
                     */}
            </div>
          </Modal>
        </CenteredForm>
        <style
          dangerouslySetInnerHTML={{
            __html: `
body{
   background-image: url("/background.jpg");
   background-size: cover;
   background-color: rgb(192, 199, 203) !important;
 }`,
          }}
        />
      </div>
    );
  }
  subDomainFocus() {
    if (!this.state.autoFocusSubdomainCalled) {
      this.state.autoFocusSubdomainCalled = true;
      this.props.initialize(
        {
          plan: this.refs.plan.value,
          email: this.refs.email.value,
          password: this.refs.password.value,
          specialityId: this.refs.specialityId.value,
          firstName: this.refs.firstName
            ? this.refs.firstName.value
            : undefined,
          lastName: this.refs.lastName ? this.refs.lastName.value : undefined,
          multiDoctor: this.refs.multiDoctor.value,
          multiDoctorNames: this.refs.multiDoctorNames
            ? this.refs.multiDoctorNames.value
            : undefined,
          birthdate: this.refs.birthdate.value,
          companynumber: this.refs.companynumber.value,
          companyname: this.refs.companyname.value,
          subdomainText: this.modifiySubdomain(
            this.refs.companyname.value || ""
          ),
        },
        true
      );
    }
  }

  modifiySubdomain(value) {
    let str = value.toLowerCase();
    str = str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ /g, "");
    return str;
  }

  isDomainAlreadyUsed(error) {
    if (!!error && error.subdomain && error.subdomain.length) {
      return true;
    }
    return false;
  }

  openModal() {
    this.setState({ isModalOpen: true });
  }

  closeModal(error) {
    if (!!error && error.subdomain) {
      error.subdomain.length = 0;
    }
    this.setState({ isModalOpen: false });
  }
}

const mapStateToProps = (state) => ({
  signup: state.signup,
  specility: state.specility,
  snackbarMessage: getLatestMessage(state) || {},
});
const ConnectedSignup = connect(mapStateToProps, {
  signupRequest,
  specilityRequest,
})(UserNotAuthenticated(Signup));

export default reduxForm({
  form: "signup",
})(ConnectedSignup);



// WEBPACK FOOTER //
// ./src/pages/signup/Signup.jsx